module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xy-dynamic-code-view"
  }, [_c('x-dialog', {
    attrs: {
      "dialog-style": {
        'background-color': 'transparent',
        'z-index': 4999
      },
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "dynamic-dialog-container"
  }, [_c('div', {
    staticClass: "top-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dynamicCode),
      expression: "dynamicCode"
    }],
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.dynamicCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dynamicCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "vCode",
      "src": _vm.imageUrl
    },
    on: {
      "click": _vm.switchDynamicCode
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotice),
      expression: "showNotice"
    }],
    staticClass: "notice-container"
  }, [_c('icon', {
    staticClass: "notice-icon",
    attrs: {
      "className": "icon",
      "symbol": "red-notice-icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.noticeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "close-btn-container",
    on: {
      "click": _vm.closeSelf
    }
  }, [_c('icon', {
    staticClass: "close-icon",
    attrs: {
      "className": "icon",
      "symbol": "close-icon"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "sure-button",
    class: {
      'button-enable': _vm.sureButtonEnabled, 'button-disable': !_vm.sureButtonEnabled
    },
    attrs: {
      "disabled": !_vm.sureButtonEnabled
    },
    on: {
      "click": _vm.validateCode
    }
  }, [_vm._v("确定\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27ae6bca!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-dynamicVerifyCode-view.vue
// module id = 395
// module chunks = 36